import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { withRouter } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { roles, exerciseTypes } from '../../common/config'
import { getPublicLessons } from '../../common/lessons/actions'
import { loadSubjects } from '../../common/subjects/actions'
import subjectsMessages from '../../common/translations/subjectsMessages'
import { loadTags, loadTagsByLanguage, loadTagsBySubject } from '../../common/tags/actions'
import { getPublicTests } from '../../common/tests/actions'
import { loadUsers, clearUser, followUser } from '../../common/users/actions'
import SmallLoader from '../components/SmallLoader'
import {
  Button,
  LessonsList,
  LessonsTiles,
  UsersList,
  Tag,
  SelectInput,
} from '../components'
import { LessonDetailPage } from '../pages'

class SearchPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lessonsQuery: '',
      userQuery: '',
      searchQuery: '',
      savedIds: [],
      selectedTags: [],
      searchType: 'lesson',
      submittedUser: false,
      submittedLesson: true,
      mobileTags: false,
      subject: null,
    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    const { loadTags, loadTagsByLanguage, loadSubjects, viewer } = this.props
    
    loadSubjects()
    
    // loadTagsByLanguage(viewer && viewer.foreignLanguage || 'en')
  }

  componentWillReceiveProps(nextProps) {
    const { subjects, publicLessons } = nextProps
    const prevSubjects = this.props.subjects
    const prevPublicLessons = this.props.publicLessons

    if (!prevSubjects.length && subjects && subjects.length) {
      const englishSubject = subjects.find(s => s.name === 'english')

      this.subjectChange(englishSubject.id)
    }

    if (!prevPublicLessons.length && publicLessons && publicLessons.length) {
      this.setState({ submittedLesson: true })
    }
  }

  componentWillUnmount() {
    this.props.clearUser()
  }

  componentDidCatch(error, info) {
    console.log('error - SearchPage')
    console.log(error)
    console.log('info')
    console.log(info)
  }

  subjectChange(value) {
    const { loadTagsBySubject } = this.props
    this.setState({ subject: value })
    loadTagsBySubject(value)
  }

  handleSubmit(e, searchType) {
    // TODO refactor
    if (e) {
      e.preventDefault()
    }
    const { loadUsers, getPublicLessons, getPublicTests } = this.props
    const { searchQuery, selectedTags } = this.state

    if (searchType === 'user') {
      loadUsers(searchQuery)
      this.setState({ submittedUser: true })
    } else if (searchType === 'lesson') {
      let query = ''
      if (searchQuery) {
        query = `name=${searchQuery}`
      }
      if (selectedTags) {
        query = `${query ? `${query}&` : ''}tags=${JSON.stringify(selectedTags)}`
      }
      getPublicLessons(query)
      this.setState({ submittedLesson: true })
    } else if (searchType === 'test') {
      getPublicTests(searchQuery)
      this.setState({ submittedTest: true })
    }
  }

  toggleTag(t) {
    const { selectedTags, searchType } = this.state

    if (selectedTags.find(st => st === t.id)) {
      this.setState({
        selectedTags: selectedTags.filter(ct => ct !== t.id),
        submittedLesson: true },
        () => this.handleSubmit(null, searchType),
      )
    } else {
      this.setState({
        selectedTags: [...selectedTags, t.id],
        submittedLesson: true },
        () => this.handleSubmit(null, searchType),
      )
    }
  }

  handleSearchTypeChange(searchType) {
    this.setState({ searchType, searchQuery: '' })
  }

  render() {
    const { viewer, tags, foundUsers, followUser, publicLessons, intl, location,
      currentLesson, loadingPublicLessons, isTestForm, subjects, fieldsLessons } = this.props
    const { searchType, selectedTags, mobileTags } = this.state
    if (!publicLessons) {
      return <span>Loading...</span>
    }
    const lessons = publicLessons && publicLessons.toJS()
    // const tests = publicTests && publicTests.toJS()
    const users = foundUsers && foundUsers.toJS()
    const isSearchPageUrl = location.pathname.includes('search')

    /*
    const searchTypes = {
      user: { label: intl.formatMessage(messages.userLabel) },
      lesson: { label: intl.formatMessage(messages.lessonLabel) },
    }
    */

    return (
      <div className="search-page">
        <div className="search">
          {
            isSearchPageUrl &&
            <SelectInput
              label={intl.formatMessage(messages.subject)}
              defaultValue={intl.formatMessage(messages.subjectLabel)}
              options={subjects.map(subject => ({
                ...subject,
                label: intl.formatMessage(subjectsMessages[subject.name]),
              }))}
              onChange={(e) => this.subjectChange(e.target.value)}
            />
          }
          {/*
          <form onSubmit={(e) => this.handleSubmit(e, searchType)}>
            <div className="search-form">
              <div className="input-box float-left">
                <input
                  type="text"
                  name="search"
                  autoComplete="off"
                  placeholder=" "
                  className="search-input"
                  value={this.state.searchQuery}
                  onChange={(event) => this.setState({ searchQuery: event.target.value })}
                />
                <span className="floating-label">{searchTypes[searchType].label}</span>
              </div>
              <Button id="search" positive className="float-right" type="submit">
                {intl.formatMessage(messages.search)}
              </Button>
            </div>
          </form>
          */}
          {
            searchType === 'lesson' &&
            <div className={`tags-wrapper ${mobileTags ? 'mobile' : ''} `}>
              <h3 className="tags-wrapper-title spacing-top">
                {intl.formatMessage(messages.tagsTitle)}
              </h3>
              <div
                onClick={() => this.setState({ mobileTags: false })}
                className="tags-wrapper-close"
              >
                <FontAwesomeIcon icon="times-circle" size="2x" />
              </div>
              <div className="tags-list width-full float-left">
                {
                  tags.map(t => (
                    <Tag
                      key={t.id}
                      tag={t}
                      selected={!!selectedTags.find(st => st === t.id)}
                      onClick={() => this.toggleTag(t)}
                    />
                  ))
                }
              </div>
              <React.Fragment>
                <Button
                  positive
                  big
                  onClick={() => this.setState({ mobileTags: !mobileTags })}
                  className="update-search"
                >
                  {intl.formatMessage(messages.showResults)}
                </Button>
                {
                  !mobileTags &&
                  <Button
                    onClick={() => this.setState({ mobileTags: !mobileTags })}
                    className="show-all-link disable-spacing-left spacing-top"
                  >
                    {intl.formatMessage(messages.showAllTags)}
                  </Button>
                }
                
              </React.Fragment>
            </div>
          }
          {
            loadingPublicLessons ?
              <SmallLoader />
            :
              <React.Fragment>
                {
                  searchType === 'lesson' && this.state.submittedLesson &&
                  <div className="width-full float-left spacing-top">
                    <h3>{intl.formatMessage(messages.foundexercises)}:</h3>
                    {
                      lessons && lessons.length ?
                        <LessonsTiles
                          lessons={lessons}
                          fieldsLessons={fieldsLessons}
                          isTestForm={isTestForm}
                        />
                        /*
                          <LessonsList isSearchPage isTestForm={isTestForm} lessons={lessons} />
                        */
                      :
                        <p>{intl.formatMessage(messages.notFoundexercises)}</p>
                    }
                    {
                      currentLesson &&
                      <div className="popup-wrapper">
                        <div className="popup-content">
                          <LessonDetailPage
                            isPopup
                            isTestForm={isTestForm}
                          />
                        </div>
                      </div>
                    }
                  </div>
                }
                {
                  !isTestForm && viewer &&
                  <div className="large-vertical-spacing">
                    <p>{intl.formatMessage(messages.notProperexercises)}</p>
                    <Link to="/app/create-lesson">
                      <Button
                        positive
                        className="disable-spacing-left"
                      >
                        {intl.formatMessage(messages.createOwnexercise)}
                      </Button>
                    </Link>
                  </div>
                }
              </React.Fragment>
          }
          {
            searchType === 'user' && this.state.submittedUser &&
            <div>
              <h3>{intl.formatMessage(messages.foundUsers)}:</h3>
              {
                users && users.length ?
                  <UsersList users={users} />
                :
                  <p>{intl.formatMessage(messages.notFoundUsers)}</p>
              }
            </div>
          }
        </div>
      </div>
    )
  }
}

SearchPage.defaultProps = {
  loadingPublicLessons: false,
  isTestForm: false,
  publicLessons: null,
  currentLesson: null,
  publicTests: null,
  foundUsers: null,
  viewer: null,
  tags: [],
  subjects: [],
}

SearchPage.propTypes = {
  intl: PropTypes.object.isRequired,
  getPublicLessons: PropTypes.func.isRequired,
  getPublicTests: PropTypes.func.isRequired,
  loadTagsByLanguage: PropTypes.func.isRequired,
  loadSubjects: PropTypes.func.isRequired,
  loadTagsBySubject:  PropTypes.func.isRequired,
  loadUsers: PropTypes.func.isRequired,
  clearUser: PropTypes.func.isRequired,
  followUser: PropTypes.func.isRequired,
  loadTags: PropTypes.func.isRequired,
  publicLessons: PropTypes.object,
  currentLesson: PropTypes.object,
  publicTests: PropTypes.object,
  foundUsers: PropTypes.object,
  viewer: PropTypes.object,
  tags: PropTypes.array,
  loadingPublicLessons: PropTypes.bool,
  isTestForm: PropTypes.bool,
  subjects: PropTypes.array,
}

SearchPage = withRouter(SearchPage)

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    publicLessons: state.lessons.publicLessons,
    currentLesson: state.lessons.currentLesson,
    loadingPublicLessons: state.lessons.loadingPublicLessons,
    publicTests: state.tests.publicTests,
    foundUser: state.users.current,
    foundUsers: state.users.all,
    tags: state.tags.all,
    subjects: state.subjects.all,
  }), { getPublicLessons, getPublicTests, loadUsers, clearUser, loadTagsBySubject,
    followUser, loadTags, loadTagsByLanguage, loadSubjects }),
  injectIntl,
)

export default enhance(SearchPage)

const messages = defineMessages({
  search: {
    id: 'search.page.search',
    defaultMessage: 'Hľadať',
  },
  userLabel: {
    id: 'search.page.userLabel',
    defaultMessage: 'Email alebo meno',
  },
  lessonLabel: {
    id: 'search.page.lessonLabel',
    defaultMessage: 'Názov cvičenia',
  },
  exercises: {
    id: 'search.page.exercises',
    defaultMessage: 'Cvičenia',
  },
  users: {
    id: 'search.page.users',
    defaultMessage: 'Užívatelia',
  },
  tagsTitle: {
    id: 'search.page.tagsTitle',
    defaultMessage: 'Vyberte okruhy cvičení',
  },
  foundexercises: {
    id: 'search.page.foundexercises',
    defaultMessage: 'Nájdené cvičenia',
  },
  notFoundexercises: {
    id: 'search.page.notFoundexercises',
    defaultMessage: 'Neboli nájdené žiadne cvičenia.',
  },
  foundUsers: {
    id: 'search.page.foundUsers',
    defaultMessage: 'Nájdení užívatelia',
  },
  notFoundUsers: {
    id: 'search.page.notFoundUsers',
    defaultMessage: 'Neboli nájdení žiadny užívatelia.',
  },
  createOwnexercise: {
    id: 'search.page.createOwnexercise',
    defaultMessage: 'Vytvoriť vlastné cvičenie',
  },
  notProperexercises: {
    id: 'search.page.notProperexercises',
    defaultMessage: 'Nenašli ste vhodné cvičenia?',
  },
  showAllTags: {
    id: 'search.page.showAllTags',
    defaultMessage: 'Zobraziť viac tagov',
  },
  showResults: {
    id: 'search.page.showResults',
    defaultMessage: 'Zobraziť výsledky',
  },
  subject: {
    id: 'lesson.formHeader.subject',
    defaultMessage: 'Predmet',
  },
  subjectLabel: {
    id: 'lesson.formHeader.subjectLabel',
    defaultMessage: 'Vyberte predmet',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/SearchPage.js